export const PaymentOnHold = {
  TradeState: 35
};

export enum PostSaleCategories {
  PAYMENT = 0,
  SHIPPING = 1,
  INSPECTION = 2,
  BUY_BACK_GUARANTEE = 5,
  PUSH_TO_ADESA = 4
}

export enum PostSaleOwnershipStatus {
  EMPTY = 0,
  RECEIVED = 1,
  ERROR = 2,
  APPROVED = 3
}

export enum PostSaleLineItems {
  OWNERSHIP = 'ownership',
  LIEN_RELEASE = 'lien_release',
  AMOUNT = 'amount',
  DATE_ORDERED = 'date_ordered',
  TRANSPORT_COMPANY = 'transport_company',
  ESTIMATED_PICK_UP_DATE = 'estimated_pick_up_date',
  PICK_UP_LOCATION = 'pick_up_location'
}

export const PostSaleLineItemsDocumentsKeys = [
  PostSaleLineItems.OWNERSHIP,
  PostSaleLineItems.LIEN_RELEASE
];

export const PostSaleLineItemsStatus = {
  [PostSaleLineItems.OWNERSHIP]: [
    { status: 0, key: 'owing' },
    { status: 1, key: 'processing' },
    { status: 2, key: 'upload' },
    { status: 3, key: 'verified' }
  ],
  [PostSaleLineItems.LIEN_RELEASE]: [
    { status: 0, key: 'owing' },
    { status: 1, key: 'processing' },
    { status: 2, key: 'verified' },
    { status: 3, key: 'upload' }
  ]
};

export enum EtrUploadedDocumentType {
  TITLE = 'Title',
  LIEN = 'Lien'
}
